import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftRight } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { toast } from '@/stores/toastStore';
import { extractError } from '@/api/client';

/**
 * Sélecteur de société (lot 1, étape 1.7) — en haut de la barre de gauche, sur toutes les pages.
 * Visible seulement pour les personnes rattachées à plusieurs sociétés ouvrables. Les dormantes sont listées mais
 * désactivées. La sécurité ne dépend pas de cette liste : chaque requête est contrôlée (rattachement + base cloisonnée).
 */
export const SocieteSelector = () => {
  const { societes, filiale, pdgViewFiliale, changerSociete } = useAuthStore();
  const navigate = useNavigate();
  const [enCours, setEnCours] = useState(false);
  if (!societes || societes.filter((s) => s.ouvrable).length < 2) return null;

  const courante = pdgViewFiliale ?? societes.find((s) => s.origine)?.filialeKey ?? filiale?.filialeKey ?? '';

  const choisir = async (filialeKey: string) => {
    if (filialeKey === courante) return;
    setEnCours(true);
    try {
      await changerSociete(filialeKey);
      navigate('/');
    } catch (e) {
      toast.error('Changement de société impossible', extractError(e).message);
    } finally {
      setEnCours(false);
    }
  };

  return (
    <label className="ds-societe-selector" title="Changer de société">
      <ArrowLeftRight size={13} aria-hidden />
      <span className="sr-only">Société</span>
      <select
        value={courante}
        disabled={enCours}
        onChange={(e) => void choisir(e.target.value)}
        aria-label="Changer de société"
      >
        {societes.map((s) => (
          <option key={s.filialeKey} value={s.filialeKey} disabled={!s.ouvrable}>
            {s.name}{s.origine ? ' (ma société)' : ''}{s.statut === 'dormante' ? ' — dormante' : ''}
          </option>
        ))}
      </select>
    </label>
  );
};
